import React,{useEffect} from "react";

import Funlove from './Funlove'

function App() {
  return (
    <Funlove/>
  );
}

export default App;
